import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=7d75730f&scoped=true"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=7d75730f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d75730f",
  null
  
)

export default component.exports